import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { PropType } from 'vue';
import type { GuideArmPosition, GuideType } from '@/modules/ConfiguratorJoints/composables/useGuidesAndType';
import { resolveCornerJointGuideAsset } from '@/modules/ConfiguratorJoints/helpers/CornerJointHelper';
import type { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';


export default /*#__PURE__*/_defineComponent({
  __name: 'CornerJointArmPreview',
  props: {
    position: { type: Number as PropType<GuideArmPosition>, required: true },
    leftGuideType: { type: String as PropType<GuideType | null>, default: null },
    rightGuideType: { type: String as PropType<GuideType | null>, default: null },
    canvasTemplateConfiguration: {
        type: Object as PropType<JointCanvasTemplateConfiguration>,
        required: true,
    },
},
  setup(__props) {

const props = __props;



/* === Guide presentation === */
function resolvePreviewGuide(slot: 'leftBottom' | 'rightTop', guideType: GuideType | null) {
    const guide = resolveCornerJointGuideAsset(props.canvasTemplateConfiguration, slot, guideType);
    if (!guide) {
        return null;
    }

    const isWireOrInox = guideType === 'wire-guide' || guideType === 'inox-guide';
    const imageClass = {
        'corner-joint-arm-preview__guide-image--compact': isWireOrInox,
        'corner-joint-arm-preview__guide-image--vertical': !isWireOrInox,
        'corner-joint-arm-preview__guide-image--alu': guideType === 'alu-guide',
    };

    return {
        ...guide,
        imageClass,
        guideClass: isWireOrInox ? 'corner-joint-arm-preview__guide--compact' : null,
        imageStyle: { '--guide-aspect-ratio': String(guide.asset.heightMm / guide.asset.widthMm) },
    };
}

const leftGuide = computed(() => resolvePreviewGuide('leftBottom', props.leftGuideType));

const rightGuide = computed(() => resolvePreviewGuide('rightTop', props.rightGuideType));

return { __sfc: true,props, resolvePreviewGuide, leftGuide, rightGuide }
}

})